<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter" @submit.native.prevent>
            <el-form-item label="选占状态：">
                <el-select v-model="searchForm.state" clearable>
                    <el-option v-for="item in pkgStateOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="号码：">
                <el-input v-model.trim="searchForm.newPhone" clearable></el-input>
            </el-form-item>
             <el-form-item label="对应产品：" prop="shopId">
                    <el-select v-model="searchForm.shopId" clearable>
                        <el-option v-for="item in haokaList" :value="item.id" :key=" item.name" :label="item.name"></el-option>
                    </el-select> 
                </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getPkgListPageHandle">搜索查询</el-button>
                  <el-button type="success" plain icon="el-icon-delete" class="onlyBtn" @click="showBatchChgStateHandler12()">批量添加</el-button>
                  <el-button type="danger" plain icon="el-icon-delete" class="onlyBtn" @click="showBatchChgStateHandler1()">批量删除</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >           
            <el-table-column prop="id" label="系统编码" width="120px"></el-table-column>
            <el-table-column prop="phone" label="手机号"></el-table-column>
            <el-table-column prop="shopName" label="所属商品"></el-table-column>
             <el-table-column prop="stateName" label="选占状态"></el-table-column>
            <el-table-column prop="createTime" label="添加时间" width="200px"></el-table-column>
            <el-table-column label="操作">
                <template v-slot="scope">
                    <el-button type="danger" size="small" @click="showEditPkg(scope.row)">删除</el-button>
                </template>             
            </el-table-column>
        </el-table>  
                 
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>    
        
          <el-dialog :append-to-body="true"  title="批量删除" :visible.sync="batchOptVisible1" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="searchForm" :model="searchForm"   label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel"> 
                    <el-upload ref="upload" :action="uploadUrl('haoka/delete/phone')" :headers="setHeader()" :auto-upload="false" :data="batchOptForm" :on-change="handleChange" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="downPdf()">删除模板</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
        
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler1">确 定</el-button>
            </div> 
        </el-dialog>      
        <el-dialog :append-to-body="true"  title="批量添加" :visible.sync="batchOptVisible12" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="searchForm" :model="searchForm"   label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel"> 
                    <el-upload ref="upload" :action="uploadUrl('haoka/add/phone')" :headers="setHeader()" :auto-upload="false" :data="batchOptForm" :on-change="handleChange" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="downPdf()">添加模板</el-button>
                    </el-upload>
                </el-form-item>
                 <p style="color:red">备注： 市面上百分之80的号卡选号页面 都是用的虚假号码 只是促销用户购买而已。 所以不是直接对接运营商 这个产品选项就不要选</p>
             <el-form-item label="对应产品：" prop="shopId">
                    <el-select v-model="searchForm.shopId" clearable>
                        <el-option v-for="item in haokaList" :value="item.id" :key=" item.name" :label="item.name"></el-option>
                    </el-select> 
                </el-form-item>
            </el-form>
            
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler12">确 定</el-button>
            </div> 
        </el-dialog>          
    </div>
</template>
<script>
import {getPkgListPage, addPkg, updatePkg, getPkgDetail, changePkgState, adminPkgSort} from '@/api/package.js'
import common from '@/utils/common.js'
export default {
    data(){     
        return {
            frontImgUrl:'',
            existBackImg:false,
            searchForm: {
                state: '',
                newPhone:'',
                shopId:'',
                type: '',
                supplierType: '',
                shopState: null,
                shopName: '',
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0,
            },            
            pkgTypeOption: [],
            pkgStateOption: [
                {'code':0,'description':'未选占'},
              {'code':1,'description':'已选占'}
            ],
              pkgStatesOption: [
                {'code':1,'description':'上架'},
              {'code':2,'description':'下架'}
            ],
             agentStateOption: [
                {'code':1,'description':'允许'},
              {'code':2,'description':'不允许'}
            ],
            supplierOption: [],
            addOrEditPkgForm: {
                shopName: '',
                shopPrice: '',
                shopImgs: '',
                shopState: '',
                shopOldPrice: '',
                shopFree: '',
                shopAgentPrice:'',
                isShowAgent: '',
                shopHeadImg: '',
                buyCount: 0,
                collectCount: 0 ,
                sort:0  ,
                         
            },
            haokaList:[],
            batchOptVisible1:false,
            batchOptVisible12:false,
            unit: 'G',
            currentId: '',
            addFlag: null,
            addPkgVisibale: false,
            pkgGroup: [],
            myPkgGroup: [],
            title: ''
        }
    },
    methods: {
        downPdf(){
            var link = document.createElement('a');
                link.setAttribute('download', '');
                link.href = '../../../doc/phones.xls';
                link.click();
        },
          showBatchChgStateHandler1(){
            this.batchOptVisible1 = true;
        },
         showBatchChgStateHandler12(){
            this.batchOptVisible12 = true;
        },
        
        cancel(){
            this.batchOptVisible1=false;
              this.batchOptVisible12=false;
            this.addPkgVisibale = false;    
            this.$refs.addOrEditPkgForm.resetFields();  
        },
        showbtnText(state){
            return common.showTxtByState(state, {0: '上架', 1: '下架'})
        },
        //同步上游套餐
        updateUpPkg(){
            common.sysRequest('pkg/update/up/pkg', null, 'get').then(res => {
                if(res.data.code == 200){
                    this.getPkgListPageHandle();
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        numberHandle(e){          
            var reg = /^\d+(\.\d{1,2})?/;
            if(reg.exec(e.target.value)) {
                e.target.value = reg.exec(e.target.value)[0];
            }                  
        },
        getPkgListPageHandle($event){   
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);

                 common.sysRequest('haoka/list/phone', data, 'post').then(res => {
                if(res.data.code == 200){
                     common.listCallback(this, res, 'tbpg'); 
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },   
        showAddPkg(){
            this.addPkgVisibale = true;
            this.addFlag = true;
            this.title = '新增商品';
        },
         sureBatchChgStateHandler1(){ 
            this.$refs.searchForm.validate(valid => {
                if(valid) {           
                    this.$refs.upload.submit();
                }
            });
                     this.getPkgListPageHandle();

        },
         sureBatchChgStateHandler12(){ 
            this.$refs.searchForm.validate(valid => {
                if(valid) {           
                    this.$refs.upload.submit();
                }

            });
                    this.getPkgListPageHandle();

        },
        showEditPkg(row){
            var data={
                id:row.id
            }
            common.sysRequest("haoka/list/phone/delete", data, 'post').then(res=>{
                    
                     if(res.data.code == 200){
                         this.getPkgListPageHandle();
                      this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }
                      }).catch(err=> console.error(err));
                         
        },
        addOrEidtPkgHandle(){
            this.$refs.addOrEditPkgForm.validate(valid => {
                if(valid) {
                    let fd = new FormData();
            Object.keys(this.addOrEditPkgForm).forEach((key) => {
                fd.append(key, this.addOrEditPkgForm[key]);
            })
            fd.append('appPopImg',this.$refs.file1.files[0]);
            fd.append('appTImg',this.$refs.file2.files[0]);
                    if(this.addFlag == true){
                        common.sysRequest("app/pc/insert/store", fd, 'post').then(res=>{
                                if(res.data.code == 200){
                                this.$message.success(res.data.message);
                                     callback(res);
                            for (let val in this.addOrEditPkgForm) {
                                this.addOrEditPkgForm[val] = "";
                            }

                            }else{
                                this.$message.error(res.data.message);
                            }
                      }).catch(err=> console.error(err));
                    }else{
                         fd.append('id',this.currentId);
                           common.sysRequest("app/pc/update/store", fd, 'post').then(res=>{
                             if(res.data.code == 200){
                                this.$message.success(res.data.message);
                                 callback(res);
                            }else{
                                this.$message.error(res.data.message);
                            }
                           
                      }).catch(err=> console.error(err));             
                    }                    
                }
                var _this = this;
                function callback(res){
                    if(res.data.code == 200){
                        _this.getPkgListPageHandle();
                        _this.addPkgVisibale = false;
                        
                    }else{                        
                        _this.$message.error(res.data.message)
                    }                     
                }
            })             
        },
        changePkgStateHandle(id){
            var data = {
                id
            }
            changePkgState(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.getPkgListPageHandle();
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        updateSortNo(row){
            //修改排序号
            var data = {
                id: row.id,
                sort: row.sort
            }
             common.sysRequest('app/pc/update/store/sort', data, 'post').then(res => {
                    if(res.data.code == 200){
                    this.getPkgListPageHandle();
                   }
                })
            
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getPkgListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getPkgListPageHandle();
        },
        //选择套餐组
        whenChoosePagGroup(val){
            for(let index in this.pkgGroup){
                if(this.pkgGroup[index].id == val){
                    this.addOrEditPkgForm.supplierType = this.pkgGroup[index].supplierType;
                }
            }
            if(this.addOrEditPkgForm.supplierType == 66){
                common.sysRequest('external/pkg/list', null, 'get').then(res => {
                    if(res.data.code == 200){
                        this.myPkgGroup = res.data.data.map.pkgs;
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }
            
        }

    },
    created () {
        this.getPkgListPageHandle();
        common.gethaokaList(this, 'haokaList');
    }  
}
</script>
<style lang="less" >
.input-with-select .el-input {
    width: 60px;
}
</style>

